import { render, staticRenderFns } from "./transportation.vue?vue&type=template&id=b0f459b6&"
import script from "./transportation.vue?vue&type=script&lang=js&"
export * from "./transportation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports